import * as PIXI from "pixi.js";
import { ShockwaveFilter } from "@pixi/filter-shockwave";
import EventEmitter from "./EventEmitter";

// import { ShaderSystem, Renderer } from "@pixi/core";
// import { install } from "@pixi/unsafe-eval";

// // Apply the patch to PIXI
// install({ ShaderSystem });

export default class ShockwaveImage extends EventEmitter {
  constructor(
    url,
    container,
    size = { w: 512, h: 512 },
    options = {
      amplitude: 150,
      wavelength: 200,
      speed: 1000,
      radius: 512,
    }
  ) {
    super();
    this.handler = {
      down: this.onMouseDown.bind(this),
      contextMenu: this.onContextMenu.bind(this),
    };
    this.filter_options = options;
    this.app = new PIXI.Application({
      width: size.w,
      height: size.h,
      // backgroundAlpha: 0,
      backgroundColor: 0xffffff,
      preserveDrawingBuffer: true,
    });
    this.view = this.app.view;
    container.appendChild(this.app.view);
    if (url) {
      this.original_url = url;
      this.b64_image = url;
      const loader = PIXI.Loader.shared;
      loader.add("backgroundImage", url).load(this.setup.bind(this));
    }
    this.imageUpdatedAtLeastOnce = false;
    // listener for HINTS
    const resultImage = document.querySelector("#resultImage");
    resultImage.addEventListener("mousedown", this.handler.down);
    resultImage.addEventListener("touchstart", this.handler.down);
    resultImage.addEventListener("contextmenu", this.handler.contextMenu);
  }
  onMouseDown(e) {
    e.preventDefault();
    // ---> show hint for color on the right panel !
    console.log("NOT HERE, on the other panel");
    this.raiseEvent("badclick", []);
  }
  onContextMenu(e) {
    e.preventDefault();
    return false;
  }

  set loadingState(val) {
    this.isLoading = val;
    if (val == true) {
      this.filter.time = 0;
      this.filter.center = [this.view.width / 2, this.view.height / 2];
      this.inMotion = true;
      console.log(this);
    }
  }
  get loadingState() {
    return this.isLoading;
  }

  onResize(dimension) {
    //this part resizes the canvas but keeps ratio the same
    try {
      const renderer = this.app.renderer;
      renderer.view.style.width = dimension.width + "px";
      renderer.view.style.height = dimension.height + "px";
      renderer.resize(dimension.width, dimension.height);
      const scale = dimension.width / 512;
      this.bImage.scale.set(scale, scale);
      this.reset();
    } catch (error) {
      console.log("no image to scale", error);
    }
  }

  changeTexture(url) {
    this.b64_image = url;
    const loader = PIXI.Loader.shared;
    loader.add("replacementTexture", url).load(this.newTextureReady.bind(this));
  }
  directChangeTexture(url) {
    this.b64_image = url;
    const loader = PIXI.Loader.shared;
    try {
      loader
        .add("replacementTexture", url)
        .load(this.newTextureReadyDirect.bind(this));
    } catch (error) {
      console.log(error);
    }
  }
  newTextureReady(loader, resources) {
    this.newTexture = resources.replacementTexture.texture;
    this.newTextureIsReady = true;
    this.imageUpdatedAtLeastOnce = true;
    loader.reset();
    loader.destroy();
    console.log("NEWTEXTURE READY");
    // this.raiseEvent("textureupdated", []);
  }
  newTextureReadyDirect(loader, resources) {
    this.bImage.texture = resources.replacementTexture.texture;
    loader.reset();
    loader.destroy();
    this.imageUpdatedAtLeastOnce = false;
    console.log("NEWTEXTURE DIRECT READY");
  }

  setup(loader, resources) {
    this.bImage = PIXI.Sprite.from(resources.backgroundImage.texture);
    this.bImage.position.set(-2, -2);
    this.support = new PIXI.Container();
    this.support.addChild(this.bImage);
    this.bImage.scale.set(1.007);
    this.app.stage.addChild(this.support);
    this.setupShockwaveFilter();
  }
  setupShockwaveFilter() {
    this.filter = new ShockwaveFilter([1024, 1024], this.filter_options);
    this.bImage.filters = [this.filter];
  }

  click(e) {
    this.filter.center = [e.layerX, e.layerY];
    this.filter.time = 0;
    this.inMotion = true;
  }

  update() {
    /*
      CALCULATION FOR THE LIMITS while loading: 
      speed 1000 :
      loop: 0.35
      stop:0.5
      changetexture:0.1

      speed 500:
      loop:0.8
      stop:1
      changetexture:0.3
    */
    // console.log("draw");

    if (this.inMotion && !this.isLoading) {
      this.filter.time += 0.005;
      if (this.newTextureIsReady && this.filter.time < 0.05)
        this.canFlip = true;
      if (this.canFlip && this.filter.time > 0.1) {
        this.newTextureIsReady = false;
        this.canFlip = false;
        this.bImage.texture = this.newTexture;
      }
      if (this.filter.time >= 0.35) this.inMotion = false;
    } else if (this.inMotion && this.isLoading) {
      //   this.filter.time =
      //     this.filter.time >= 0.35 ? 0 : (this.filter.time += 0.005);
      this.filter.time += 0.005;
      if (this.filter.time > 0.35 && !this.stopEffect) {
        this.filter.time = 0;
      } else if (this.filter.time > 0.5 && this.stopEffect) {
        this.inMotion = false;
        this.isLoading = false;
        this.stopEffect = false;
        console.log("Time to stop properly");
        this.raiseEvent("textureupdated", []);
        this.stop();
      } else {
        // console.log("time?", this.filter.time, this.stopEffect);
      }
      if (this.newTextureIsReady && this.filter.time < 0.05)
        this.canFlip = true;
      if (this.canFlip && this.filter.time > 0.1) {
        this.newTextureIsReady = false;
        this.canFlip = false;
        this.bImage.texture = this.newTexture;
        this.stopEffect = true;
        console.log("texture has changed");
      }
    }
    if (this.isRunning) {
      requestAnimationFrame(this.update.bind(this));
    }
  }
  run() {
    this.isRunning = true;
    this.update();
  }
  stop() {
    this.isRunning = false;
  }
  reset() {
    this.directChangeTexture(this.original_url);
  }
}
